import { useSyncExternalStore } from 'react'
import { loadDeviceSettings, saveDeviceSettings, type DeviceSettings } from '../storage/device'
import type { KeyValueStorage } from '../storage/preferences'

/**
 * Ajustes de este dispositivo (la latencia calibrada) como almacén reactivo. No viajan en la copia
 * de seguridad: cada altavoz tiene su retraso.
 */
function browserStorage(): KeyValueStorage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

let current: DeviceSettings = loadDeviceSettings(browserStorage())
const listeners = new Set<() => void>()

export function getDeviceSettings(): DeviceSettings {
  return current
}

export function updateDeviceSettings(next: DeviceSettings): void {
  current = next
  saveDeviceSettings(browserStorage(), current)
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function useDeviceSettings(): DeviceSettings {
  return useSyncExternalStore(subscribe, getDeviceSettings)
}
